<template>
  <div class="lawoffsuccase">
    <!-- <sec-title Text="成功案例" class="text_center" /> -->
	<div class="title">
		成功案例
		<div class="line"></div>
	</div>
    <div class="caselist between wrap">
      <div class="caseitem" v-for="item in 6" :key="item">
        <div class="ci1">非法狩猎认罪认罚量刑一年半，实判一年</div>
        <div class="ci2">
          承办律师：韦志聪，安徽金亚太律师事务所执业律师，金亚太司法研究所成员、王亚林刑辩团队成员。案情简介：2019年9月初至1...
        </div>
        <div class="ci3bom between">
          <div class="flex_start">
            <div>
              <img src="../../../assets/base/small_rentou.png" class="cove1" />
            </div>
            <div class="name">韦志聪律师案例</div>
            <div class="time">2021-04-21</div>
          </div>
          <div>
            <img
              src="../../../assets/findlawchild/offsuccescaseicon.png"
              class="jum"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import secTitle from "views/home/components/secTitle";
export default {
  components: {
    secTitle,
  },
};
</script>

<style lang="scss" scoped>
.lawoffsuccase {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  .caselist {
    padding-top: 10px;
    .caseitem {
      margin-top: 24px;
      width: 585px;
      height: 220px;
      background: #fff;
      padding: 33px 23px;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
      border-radius: 5px;
      .ci1 {
        font-size: 18px;
        color: #333333;
        line-height: 18px;
      }
      .ci2 {
        margin-top: 20px;
        font-size: 14px;
        color: #666666;
        line-height: 26px;
      }
      .ci3bom {
        margin-top: 22px;
        .cove1 {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          margin-right: 10px;
        }
        .name {
          margin-right: 30px;
          font-size: 16px;
          color: #666666;
        }
        .time {
          font-size: 14px;
          color: #999999;
        }
        .jum {
          width: 32px;
          height: 18px;
        }
      }
    }
  }
}
.title{
	position: relative;
	width: 160px;
	text-align: center;
	height: 36px;
	font-size: 38px;
	font-weight: 500;
	color: #333333;
	line-height: 30px;
	margin: 0 auto;
	.line{
		position: absolute;
		margin-left: -35px;
		top: 50px;
		left: 50%;
		width: 70px;
		height: 4px;
		background: #0465EA;
	}
}
</style>